import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsibleConsumption } from "@faire/web--source/slate/icons/foundation/ResponsibleConsumption";
import { ShareHeart } from "@faire/web--source/slate/icons/foundation/ShareHeart";
import { Sprout } from "@faire/web--source/slate/icons/foundation/Sprout";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import React from "react";
export var StyledIconByName = function(param) {
    var name = param.name, fontSize = param.fontSize, color = param.color, strokeWidth = param.strokeWidth;
    if (!name) {
        return null;
    }
    /**
     * NOTE:
     * This is not an optimal way to map icons with enum,
     * when icons mapped in this file grow to a big scale,
     * we should consider introduce a lazy icon component at Slate to avoid large bundles
     */ switch(name){
        case IFaireIcon.Type.SPROUT:
            return /*#__PURE__*/ _jsx(Sprout, {
                color: color,
                fontSize: fontSize,
                strokeWidth: strokeWidth
            });
        case IFaireIcon.Type.SHARE_HEART:
            return /*#__PURE__*/ _jsx(ShareHeart, {
                color: color,
                fontSize: fontSize,
                strokeWidth: strokeWidth
            });
        case IFaireIcon.Type.RESPONSIBLE_CONSUMPTION_AND_PRODUCTION:
            return /*#__PURE__*/ _jsx(ResponsibleConsumption, {
                color: color,
                fontSize: fontSize,
                strokeWidth: strokeWidth
            });
        default:
            return null;
    }
};
